module.exports = __webpack_public_path__ + "img/9.6112aac4.png";